import { render } from "./ContactCart.vue?vue&type=template&id=12eeee8b"
import script from "./ContactCart.vue?vue&type=script&lang=js"
export * from "./ContactCart.vue?vue&type=script&lang=js"
script.render = render

export default script